export const tableColVoid = [
  {
    label: "S/N",
    prop: "sn",
    key: "sn",
    width: 80,
    type: "sn-popver",
    show: true,
    fixed: true,
    disabled: false,
    icon: require("@/assets/images/ic_fuzhi.png"),
    icon_key: "copy",
    icon_value: true,
    content: '复制',
    icon2: require("@/assets/images/ic_chaofa.png"),
    icon_key2: "overUnderageStatus",
    icon_value2: "OVERDELIVERY",
    content2: '超发',
    icon3: require("@/assets/images/ic_qianfa.png"),
    icon_key3: "overUnderageStatus",
    icon_value3: "UNDERDELIVERY",
    content3: '欠发',
    icon4: require("@/assets/images/ic_fuchao.png"),
    icon_key4: "overUnderageStatus",
    icon_value4: "OVERDELIVERY",
    icon_key4_1: "copy",
    icon_value4_1: true,
    content4: '复制&超发',
    icon5: require("@/assets/images/ic_fuqian.png"),
    icon_key5: "overUnderageStatus",
    icon_value5: "UNDERDELIVERY",
    icon_key5_1: "copy",
    icon_value5_1: true,
    content5: '复制&欠发',
  },
  {
    label: "HQ交易号码",
    prop: "hqTransactionNumber",
    key: "hqTransactionNumber",
    width: 120,
    show: true,
    fixed: true,
    disabled: false
  },
  {
    label: "询价参照号类型",
    prop: "inquiryRefType",
    key: "inquiryRefType",
    width: 120,
    show: true,
    fixed: true,
    disabled: false
  },
  {
    label: "询价参照号",
    prop: "inquiryRefNumber",
    key: "inquiryRefNumber",
    width: 110,
    show: true,
    fixed: true,
    disabled: false
  },
  {
    label: "品牌",
    prop: "brand",
    key: "brand",
    width: 100,
    show: true,
    fixed: true,
    disabled: false
  },
  {
    label: "华强品名",
    prop: "hqProductName",
    key: "hqProductName",
    width: 100,
    show: true,
    fixed: true,
    disabled: false
  },
  {
    label: "Product Name",
    prop: "productName",
    key: "productName",
    width: 120,
    show: true,
    disabled: false
  },
  {
    label: "DESCRIPTION1",
    prop: "description1",
    key: "description1",
    width: 130,
    show: true,
    disabled: false,
    show_key: "show1"
  },
  {
    label: "产品属性1",
    prop: "productAttribute1",
    key: "productAttribute1",
    width: 100,
    show: true,
    disabled: false,
    show_key: "show1"
  },
  {
    label: "DESCRIPTION2",
    prop: "description2",
    key: "description2",
    width: 130,
    show: true,
    disabled: false,
    show_key: "show1"
  },
  {
    label: "产品属性2",
    prop: "productAttribute2",
    key: "productAttribute2",
    width: 100,
    show: true,
    disabled: false,
    show_key: "show1"
  },
  {
    label: "DESCRIPTION3",
    prop: "description3",
    key: "description3",
    width: 130,
    show: true,
    disabled: false,
    show_key: "show1"
  },
  {
    label: "产品属性3",
    prop: "productAttribute3",
    key: "productAttribute3",
    width: 100,
    show: true,
    disabled: false,
    show_key: "show1"
  },
  {
    label: "DESCRIPTION4",
    prop: "description4",
    key: "description4",
    width: 130,
    show: true,
    disabled: false,
    show_key: "show1"
  },
  {
    label: "产品属性4",
    prop: "productAttribute4",
    key: "productAttribute4",
    width: 100,
    show: true,
    disabled: false,
    show_key: "show1"
  },
  {
    label: "工艺",
    prop: "technicDesc",
    key: "technicDesc",
    width: 90,
    show: true,
    disabled: false,
    show_key: "show1"
  },
  {
    label: "technic",
    prop: "technic",
    key: "technic",
    width: 90,
    show: true,
    disabled: false,
    show_key: "show1"
  },
  {
    label: "产品信息",
    prop: "productInfoDesc",
    key: "productInfoDesc",
    width: 100,
    show: true,
    disabled: false,
    show_key: "show1"
  },
  {
    label: "productInfo",
    prop: "productInfo",
    key: "productInfo",
    width: 110,
    show: true,
    disabled: false,
    show_key: "show1"
  },
  {
    label: "车型/Car Application",
    prop: "carApplication",
    key: "carApplication",
    width: 150,
    show: true,
    disabled: false,
    show_key: "show1"
  },

  {
    label: "接单数量",
    prop: "shipmentQuantity",
    key: "shipmentQuantity",
    width: 110,
    show: true,
    disabled: false
  },
  {
    label: "使用库存数量",
    prop: "usedInventoryQuantity",
    key: "usedInventoryQuantity",
    width: 110,
    show: true,
    disabled: false
  },
  {
    label: "下单数量",
    prop: "deliveryQuantity",
    key: "deliveryQuantity",
    width: 110,
    show: true,
    disabled: false
  },
  {
    label: "产品单位",
    prop: "productUnit",
    key: "productUnit",
    show: true,
    disabled: false,
    width: 140
  },
  {
    label: "供应商",
    prop: "supplier",
    key: "supplier",
    show: true,
    disabled: false,
    width: 140
  },
  {
    label: "下单状态",
    prop: "deliveryStatus",
    key: "deliveryStatus",
    width: 90,
    show: true,
    disabled: false
  },
  {
    label: "交货进度",
    prop: "deliveryProgress",
    key: "deliveryProgress",
    width: 120,
    show: true,
    disabled: false
  },
  {
    label: "采购单价",
    prop: "purchaseUnitPrice",
    key: "purchaseUnitPrice",
    width: 90,
    show: true,
    disabled: false
  },
  {
    label: "采购折后单价",
    prop: "purchaseDiscountUnitPrice",
    key: "purchaseDiscountUnitPrice",
    key2: "purchaseUnitPrice",
    show: true,
    disabled: false,
    isEdit: true,
    width: 140
  },
  {
    label: "采购折扣",
    prop: "purchaseDiscount",
    key: "purchaseDiscount",
    width: 90,
    show: true,
    disabled: false
  },
  {
    label: "采购总价",
    prop: "purchaseTotalPrice",
    key: "purchaseTotalPrice",
    width: 120,
    show: true,
    disabled: false
  },
  {
    label: "销售单价",
    prop: "saleUnitPrice",
    key: "saleUnitPrice",
    width: 90,
    show: true,
    disabled: false
  },
  {
    label: "销售折后单价",
    prop: "saleDiscountUnitPrice",
    key: "saleDiscountUnitPrice",
    width: 130,
    key2: "saleUnitPrice",
    show: true,
    disabled: false,
    type: "discount"
  },
  {
    label: "销售折扣",
    prop: "saleDiscount",
    key: "saleDiscount",
    width: 90,
    show: true,
    disabled: false
  },
  {
    label: "销售总价",
    prop: "saleTotalPrice",
    key: "saleTotalPrice",
    width: 120,
    show: true,
    disabled: false
  },
  {
    label: "折算利润率",
    prop: "conversionProfitMargin",
    key: "conversionProfitMargin",
    width: 100,
    show: true,
    disabled: false
  },
  {
    label: "折算利润额",
    prop: "conversionProfitAmount",
    key: "conversionProfitAmount",
    width: 100,
    show: true,
    disabled: false
  },
  {
    label: "PO号码",
    prop: "poNumber",
    key: "poNumber",
    width: 120,
    show: true,
    disabled: false
  },
  {
    label: "订单拆分",
    prop: "purchaseOrderGroup",
    key: "purchaseOrderGroup",
    width: 90,
    show: true,
    disabled: false
  },
  {
    label: "生产批次号",
    prop: "batchNumber",
    key: "batchNumber",
    width: 110,
    show: true,
    disabled: false
  },
  {
    label: "出货备注",
    prop: "shippingRemark",
    key: "shippingRemark",
    width: 120,
    show: true,
    disabled: false
  },
  {
    label: "产品备注",
    prop: "remark",
    key: "remark",
    width: 120,
    show: true,
    disabled: false
  }
] as any; 